import React, { Component } from "react";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Menu, MenuItem } from "@mui/material";
import { Button, Form, Modal } from "react-bootstrap";
import VechiclesApi from "../../api/VechiclesApi";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Avatar from "@mui/material/Avatar";
import EnlargeImage from "../../customFunctions/EnlargeImage";
import getBaseUrl from "../../customFunctions/getBaseUrl";
import AuthService from "../../session/AuthService";
import { API_URL } from "../../config/app-config";
import moment from "moment";

class VehiclesGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEditData: {},
      anchorEl: null,
      showViewServiceRecord: false,
      vehicleImage: "",
      vehicleName: "",
    };
  }

  render() {
    // const baseUrl = getBaseUrl();
    console.log("this.props.VechiclesList", this.props.VechiclesList);
    return (
      <>
        <div className="adjust-grid-container">
          <div className="Center-the-Grid">
            <table id="myTable">
              <thead>
                <tr style={{ borderBottom: "1px solid #BCBFBE" }}>
                  <th>Vehicle Name</th>
                  <th>Model</th>
                  <th>Year Acquired</th>
                  <th>Safety Expiry Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {this.props.VechiclesList?.map((e) => (
                  <tr>
                    <td class="avatar-cell">
                      <div class="avatar">
                        <Avatar
                          alt={`${e.vehicle_name}`}
                          src={
                            e.vehicleImage !== null
                              ? `${API_URL}auth/assets/${e.vehicleImage}`
                              : null
                          }
                          sx={{
                            objectFit: "cover",
                            transition: "transform 0.3s ease-in-out", // Add a smooth transition effect
                            "&:hover": {
                              transform: "scale(1.8)",
                              zIndex: 2, // Example: Enlarge the image size on hover
                            },
                          }}
                          onClick={() => this.handleAvatarClick(e)}
                          loading="lazy"
                        >
                          {e.vehicleImage === null && (
                            <span>
                              {e.vehicle_name.charAt(0).toUpperCase()}
                            </span>
                          )}
                        </Avatar>
                        <div class="name">
                          {e.vehicle_name.charAt(0).toUpperCase() +
                            e.vehicle_name.slice(1)}
                        </div>
                      </div>
                    </td>

                    <td>{e.vehicle_model}</td>
                    <td>{e.year_acquired}</td>
                    <td>
                      {e.expiryDate
                        ? this.formatExpiryDate(e.expiryDate)
                        : "No Expiry Date"}
                    </td>
                    <td>
                      {
                        <>
                          <MoreHorizIcon
                            onClick={(event) =>
                              this.handleFilterClick(event, e)
                            }
                          />{" "}
                          <Menu
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleFilterClose2}
                            className="exclude-menu"
                          >
                            <MenuItem
                              onClick={(e) => this.handleFilterClose("edit", e)}
                            >
                              <EditOutlinedIcon />{" "}
                              <span className="inisde-the-action">Edit</span>
                            </MenuItem>
                            {AuthService.getUserTypeAdmin() !== "3" && (
                              <>
                                <MenuItem
                                  onClick={() =>
                                    this.handleFilterClose("delete")
                                  }
                                >
                                  <DeleteOutlinedIcon />{" "}
                                  <span className="inisde-the-action">
                                    Delete
                                  </span>
                                </MenuItem>
                                <MenuItem
                                  onClick={(e) =>
                                    this.handleFilterClose(
                                      "add-serviceRecord",
                                      e
                                    )
                                  }
                                >
                                  <AddCircleOutlineIcon />{" "}
                                  <span className="inisde-the-action">
                                    Add ServiceRecord
                                  </span>
                                </MenuItem>
                              </>
                            )}

                            {this.state.showViewServiceRecord && (
                              <MenuItem
                                onClick={(e) =>
                                  this.handleFilterClose(
                                    "view-serviceRecord",
                                    e
                                  )
                                }
                              >
                                <VisibilityIcon />{" "}
                                <span className="inisde-the-action">
                                  View ServiceRecord
                                </span>
                              </MenuItem>
                            )}
                          </Menu>
                        </>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
              {this.props.VechiclesList.length === 0 && (
                <>
                  {" "}
                  <div
                    style={{
                      fontSize: "larger",
                      fontWeight: "bolder",
                    }}
                  >
                    {"No Data Found"}
                  </div>{" "}
                </>
              )}
            </table>
          </div>
        </div>
        {this.state.opendeleteproductDialogue && this.deleteproductPopUp()}
        {this.state.isModalOpen && (
          <EnlargeImage
            onClose={this.handleModalClose}
            imageUrl={
              this.state.vehicleImage !== null
                ? `${API_URL}auth/assets/${this.state.vehicleImage}`
                : null
            }
          />
        )}
      </>
    );
  }

  handleAvatarClick = (e) => {
    console.log("e in check", e);

    if (e.vehicleImage !== null) {
      this.setState({
        isModalOpen: true,
        vehicleImage: e.vehicleImage,
        vehicleName: e.vehicle_name,
      });
    }
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  handleFilterClick = (event, data) => {
    this.props.getVechicleName(data);
    this.setState(
      {
        anchorEl: event.target,
        selectedEditData: data,
        showViewServiceRecord: data.allow,
      },
      () => {
        console.log("selected in selectedEd", this.state.selectedEditData);
      }
    );
  };

  handleFilterClose2 = () => {
    this.setState({
      anchorEl: null,
    });
  };

  formatExpiryDate = (expiryDate) => {
    const currentDate = moment().startOf("day"); // Start of today (00:00:00)
    const expiry = moment(expiryDate).startOf("day"); // Start of expiry day (00:00:00)

    if (!expiry.isValid() || !currentDate.isValid()) {
        return null;
    }

    const daysLeft = expiry.diff(currentDate, "days"); // Difference in full days

    console.log("Left::::", daysLeft, expiryDate); // Debugging

    if (daysLeft >= 0) {
        return <span className="text-success">{expiry.format('dddd, D MMMM YYYY')}</span>;
    } else {
        return <span className="text-danger">{expiry.format('dddd, D MMMM YYYY')}</span>;
    }
};


  // formatExpiryDate = (expiryDate) => {
  //   const currentDate = moment(); // Get the current date using Moment.js
  //   const expiry = moment(expiryDate); // Parse the expiry date

  //   // Ensure the expiry date is valid
  //   if (!expiry.isValid() || !currentDate.isValid()) {
  //     return "Invalid date";
  //   }

  //   // Calculate the difference in total days, months, and years
  //   const daysLeft = expiry.diff(currentDate, "days"); // Difference in days
  //   const monthsLeft = expiry.diff(currentDate, "months"); // Difference in months
  //   const yearsLeft = expiry.diff(currentDate, "years"); // Difference in years

  //   // Debugging the difference values
  //   console.log("Left::::", daysLeft, monthsLeft, yearsLeft);

  //   // Handle future expiry dates
  //   if (daysLeft > 0) {
  //     // If expiry is within 30 days
  //     if (daysLeft <= 30) {
  //       return `${daysLeft} day(s) remaining`;
  //     }

  //     // If expiry is more than 30 days but less than a year
  //     if (monthsLeft < 12) {
  //       const remainingDays = expiry
  //         .subtract(monthsLeft, "months")
  //         .diff(currentDate, "days");
  //       return `${monthsLeft} month(s) and ${remainingDays} day(s) remaining`;
  //     }

  //     // If expiry is more than a year away
  //     const remainingMonths = expiry
  //       .subtract(yearsLeft, "years")
  //       .diff(currentDate, "months");
  //     const remainingDaysInYear = expiry
  //       .subtract(yearsLeft, "years")
  //       .subtract(remainingMonths, "months")
  //       .diff(currentDate, "days");
  //     return `${yearsLeft} year(s), ${remainingMonths} month(s), and ${remainingDaysInYear} day(s) remaining`;
  //   } else {
  //     // Handle past expiry dates (negative values)
  //     const positiveDaysLeft = Math.abs(daysLeft); // Convert the negative days to positive
  //     const positiveMonthsLeft = Math.abs(monthsLeft); // Convert negative months to positive
  //     const positiveYearsLeft = Math.abs(yearsLeft); // Convert negative years to positive

  //     if (positiveDaysLeft <= 30) {
  //       return `${positiveDaysLeft} day(s) overdue`;
  //     }

  //     if (positiveMonthsLeft < 12) {
  //       const remainingDays = expiry
  //         .subtract(positiveMonthsLeft, "months")
  //         .diff(currentDate, "days");
  //       return `${positiveMonthsLeft} month(s) and ${remainingDays} day(s) overdue`;
  //     }

  //     const remainingMonths = expiry
  //       .subtract(positiveYearsLeft, "years")
  //       .diff(currentDate, "months");
  //     const remainingDaysInYear = expiry
  //       .subtract(positiveYearsLeft, "years")
  //       .subtract(remainingMonths, "months")
  //       .diff(currentDate, "days");
  //     return `${positiveYearsLeft} year(s), ${remainingMonths} month(s), and ${remainingDaysInYear} day(s) overdue`;
  //   }
  // };

  handleFilterClose = (getState) => {
    console.log("getState in filterClose", getState);
    console.log("getState in filterClose", this.state.selectedEditData);

    if (getState === "edit") {
      this.props.ActiveEdit(this.state.selectedEditData);
      this.handleFilterClose2();
    } else if (getState === "delete") {
      this.setState({
        opendeleteproductDialogue: true,
        anchorEl: null,
      });
    } else if (getState === "add-serviceRecord") {
      this.props.openCreateServiceRecord(this.state.selectedEditData);
    } else if (getState === "view-serviceRecord") {
      this.props.openListServiceRecord(this.state.selectedEditData);
    }

    this.setState({
      anchorEl: null,
    });
  };

  handleClose = () => {
    this.setState({
      opendeleteproductDialogue: false,
    });
  };

  deleteVechicles = () => {
    let obj = {
      vehicle_id: this.state.selectedEditData.vehicle_id,
    };

    VechiclesApi.deleteVehicle(obj).then((response) => {
      if (response.data) {
        this.handleClose();
        this.props.pageLoad();
      }
    });
  };

  deleteproductPopUp = () => {
    console.log("state id deleteproductPopUp", this.state.product_id);
    return (
      <Modal show={true} size="md" centered onHide={this.handleClose}>
        <Modal.Header closeButton className="CNSHeader">
          <h3 className="titleMd uppercase">Delete vehicle</h3>
        </Modal.Header>
        <Form noValidate>
          <Modal.Body className="">
            <div className="basicInfoWrapper newServiceFormWrapper">
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Are You Sure To Delete This Vehicle</Form.Label>
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer className="CNSFooter">
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
            <Button
              variant="success"
              type="button"
              onClick={this.deleteVechicles}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  };
}
export default VehiclesGrid;
